import { api } from 'pages/APIs';
import AbstractApiService from 'src/services/abstractApiService';
import type { dynamicObj } from 'src/pages/assets';
import { UUID } from 'crypto';
import { da } from 'date-fns/locale';

export default class decisionApiService extends AbstractApiService {
  static test(): any {
    throw new Error('Method not implemented.');
  }

  public constructor() {
    super({});
  }

  public async saveDecisionTreeRecord(data: FormData): Promise<any> {
    return super.post(api.save_decision_table, data);
  }

  public async getAllDecisionTrees(use_cache: boolean): Promise<any> {
    let cache = use_cache.toString();
    cache = cache.charAt(0).toUpperCase() + cache.slice(1);
    const url = `${api.get_decision_tables}?cache=${cache}`;
    return super.get(url);
  }

  public async deleteTable(dt_id: UUID) {
    const data = new FormData();
    data.append('id', dt_id);
    return super.post(api.delete_decision_table, data);
  }

  public async updateTable(id: string, json_data: string) {
    const data = new FormData();
    data.append('id', id);
    data.append('data', json_data);
    return super.post(api.update_decision_table, data);
  }

  public async getDocumentTypes(): Promise<any> {
    return super.get(api.get_document_types);
  }

  public async getDocumentTypeFields(documentTypeKey: string): Promise<any> {
    return super.get(
      `${api.get_document_type_fields}?doc_type=${documentTypeKey}`,
    );
  }

  public async exportDecisionTree(name: string, json_data: string) {
    const data = new FormData();
    data.append('name', name);
    data.append('data', json_data);
    return super.post(api.export_decision_tree, data);
  }

  public async getDecisionTree(treeID: string) {
    return super.get(`${api.get_decision_table_by_id}?id=${treeID}`);
  }

  public async importDecisionTree(formData: FormData) {
    return super.post(api.import_decision_tabel, formData);
  }

  public async testDecisionTree(doc_fields: string, treeID: string) {
    const data = new FormData();
    data.append('doc_fields', doc_fields);
    data.append('id', treeID);
    return super.post(api.test_decision_table, data);
  }
}
